import { Trash } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Confirmation } from 'core/components';
import { usePartBomActions } from 'partBoms/hooks';
import { IPartBom } from 'partBoms/types';
import { PartNumberHelper } from 'parts/helpers';
import { Color, Variant } from 'theme/enums';

interface IProps {
  partBom: IPartBom;
}

export const RemovePartBomButton = ({ partBom }: IProps) => {
  const [removeConfirmationOpen, setRemoveConfirmationOpen] = useState(false);

  const { t } = useTranslation();

  const { removePartBom } = usePartBomActions();

  const onRemove = async () => {
    setRemoveConfirmationOpen(false);

    await removePartBom({ ids: [partBom.id] });
  };

  return (
    <>
      <Button
        key="removePartBomButton"
        color={Color.DANGER}
        variant={Variant.SOFT}
        text={t('buttonLabelRemove')}
        startDecorator={<Trash />}
        onClick={() => setRemoveConfirmationOpen(true)}
      />

      <Confirmation
        isOpen={removeConfirmationOpen}
        title={t('titleRemovePartBom')}
        message={t('messageConfirmRemovePartBom', {
          partBomNumber: PartNumberHelper.toLabel(partBom.number),
        })}
        onConfirm={onRemove}
        onCancel={() => setRemoveConfirmationOpen(false)}
        confirmBtnColor={Color.DANGER}
      />
    </>
  );
};
